module.exports = __webpack_public_path__ + "static/media/017_gatagata.b224d405.gif";